import type TriggerEngine from "../../TriggerEngine";
import type { EventSourceResult } from "../../TriggerEngine.interfaces";

export const wireMicEvents = (engine: TriggerEngine): EventSourceResult => {
  const onMuted = (payload?: { deviceId: string }) => {
    engine.fireEvent(
      "mic_muted",
      payload ? { deviceId: payload.deviceId } : undefined,
    );
  };
  const onUnmuted = (payload?: { deviceId: string }) => {
    engine.fireEvent(
      "mic_unmuted",
      payload ? { deviceId: payload.deviceId } : undefined,
    );
  };

  engine.Radio.Microphones.on("muted", onMuted);
  engine.Radio.Microphones.on("unmuted", onUnmuted);

  return {
    unsubscribers: [
      () => engine.Radio.Microphones.off("muted", onMuted),
      () => engine.Radio.Microphones.off("unmuted", onUnmuted),
    ],
  };
};
